import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PacksDataService, PacksColumnsService } from '../../../services';
import { Pack, PacksResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-pack-details',
  templateUrl: './pack-details.component.html',
  styleUrls: ['./pack-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PackDetailsComponent implements OnInit, OnDestroy {

  public pack: Pack = {};
  public packs: Pack[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private packsDataService: PacksDataService,
    private packsColumnsService: PacksColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Pack - Details');
        this.getPack(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pack !== 'undefined') {
      this.pack = this.dynamicDialogConfig.data.pack;
    }
    this.columns = this.packsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPack(id: number): void {
    this.isLoading = true;
    this.packsDataService.getPack(id).subscribe((response: Pack|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pack = response;
      }
    });
  }

  list() {
    this.router.navigate(['/packs']);
  }

  add() {
    this.router.navigate(['/packs/add']);
  }

  edit() {
    this.router.navigate(['/packs/edit/' + this.pack.id]);
  }

}
@Component({
  selector: 'app-pack-details',
  templateUrl: './pack-details.component.html',
  styleUrls: ['./pack-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPackDetailsComponent extends PackDetailsComponent {
}

